// @flow
import React, { Component } from 'react'
import { timeFormat } from 'd3-time-format'

type Props = {
  data: [],
  k: ?string,
  showToolTip: Object => void,
  hideToolTip: () => void,
  y: number => void,
  x: number => void,
}

export default class Dots extends Component<Props> {
  render() {
    const { data, k, showToolTip, hideToolTip } = this.props
    return (
      <g>
        {data.map((d, i) => (
          <circle
            r="5"
            key={i}
            fill="#0871a5"
            data-value={d[k]}
            cy={this.props.y(d[k])}
            onMouseOut={hideToolTip}
            cx={this.props.x(d.date)}
            onMouseOver={showToolTip}
            data-key={timeFormat('%a %d')(d.date)}
          />
        ))}
      </g>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/Dots.js